import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StartPollingParams, StopPollingParams } from "./types";

export type PollingState = {
  pendingPolls: string[];
};

const initialState: PollingState = {
  pendingPolls: []
};

export const pollingSlice = createSlice({
  name: "polling",
  initialState,
  reducers: {
    startPolling(state, action: PayloadAction<StartPollingParams>) {
      const { id } = action.payload;

      if (!state.pendingPolls.includes(id)) {
        state.pendingPolls.push(id);
      }
    },

    stopPolling(state, action: PayloadAction<StopPollingParams>) {
      const { id } = action.payload;

      state.pendingPolls = state.pendingPolls.filter((pollId) => pollId !== id);
    }
  }
});

export const { startPolling, stopPolling } = pollingSlice.actions;

export const { actions: pollingActions } = pollingSlice;

export const reducer = pollingSlice.reducer;

export default pollingSlice.reducer;
